export enum ActiveSection {
  YourGuilds = "your-guilds",
  ExploreGuilds = "explore-guilds",
}
